import React from "react";
import {
    GroupPerformanceComparison,
    Header,
    PatientEngagementByGroup,
    RatingDistribution,
    Star,
    VideoViews,
} from "./styled";
import { FaStar } from "react-icons/fa";
// import Star

const group_performance_comparison = [
    {
        name: "Top Performing Group",
        type: "Cardiology Associates",
        info: "4,328 views this month",
    },
    {
        name: "Highest Rated Group",
        type: "Orthopedic Specialists",
        info: "4.9/5 average rating",
    },
    {
        name: "Most Active Group",
        type: "Neurology Partners",
        info: "14 new videos this month",
    },
];

const patient_engagement_by_group = [
    {
        group: "Cardiology Associates",
        views: 4328,
        avgWatchTime: "4:12",
        completionRate: "76%",
        avgRating: 4.8,
        trend: "+12%",
    },
    {
        group: "Neurology Partners",
        views: 3156,
        avgWatchTime: "4:12",
        completionRate: "76%",
        avgRating: 4.7,
        trend: "+12%",
    },
    {
        group: "Orthopedic Specialists",
        views: 5247,
        avgWatchTime: "4:12",
        completionRate: "76%",
        avgRating: 4.9,
        trend: "+12%",
    },
    {
        group: "Gastroenterology Group",
        views: 2845,
        avgWatchTime: "4:12",
        completionRate: "76%",
        avgRating: 4.6,
        trend: "+12%",
    },
    {
        group: "Dermatology Clinic",
        views: 1932,
        avgWatchTime: "4:12",
        completionRate: "76%",
        avgRating: 4.5,
        trend: "+12%",
    },
];

const rating_data = [
    { stars: 5, percent: 78 },
    { stars: 4, percent: 15 },
    { stars: 3, percent: 5 },
    { stars: 2, percent: 1 },
    { stars: 1, percent: 1 },
];

const Analytics = () => {
    return (
        <>
            <Header>
                <div className="row1">
                    <div className="heading_text">Group Analytics</div>
                </div>
                <div className="row2">
                    Performance metrics and engagement statistics for all
                    groups.
                </div>
            </Header>

            <VideoViews>
                <h1 className="header">Video Views by Group (Last 30 Days)</h1>
                <div className="analytics_chart">
                    Analytics chart will appear here
                </div>
            </VideoViews>

            <GroupPerformanceComparison>
                <h1 className="header">Group Performance Comparison</h1>
                <div className="display_area">
                    {group_performance_comparison.map((item, index) => (
                        <div className="card">
                            <div className="name">{item.name}</div>
                            <div className="type">{item.type}</div>
                            <div className="info">{item.info}</div>
                        </div>
                    ))}
                </div>
            </GroupPerformanceComparison>

            <PatientEngagementByGroup>
                <h1 className="header">Patient Engagement by Group</h1>
                <table>
                    <thead>
                        <tr>
                            <th>Group</th>
                            <th>Views</th>
                            <th>Avg. Watch Time</th>
                            <th>Completion Rate</th>
                            <th>Avg. Rating</th>
                            <th>Trend</th>
                        </tr>
                    </thead>
                    <tbody>
                        {patient_engagement_by_group.map((row, i) => (
                            <tr key={i}>
                                <td>{row.group}</td>
                                <td>{row.views.toLocaleString()}</td>
                                <td>{row.avgWatchTime}</td>
                                <td>{row.completionRate}</td>
                                <td>
                                    <Star />
                                    {row.avgRating}
                                </td>
                                <td className="trend">{row.trend}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </PatientEngagementByGroup>

            <RatingDistribution>
                <div className="header">Rating Distribution</div>
                {rating_data.map((item, i) => (
                    <div className="row" key={i}>
                        <div className="stars">
                            {[...Array(5)].map((_, index) => (
                                <FaStar
                                    key={index}
                                    color={
                                        index < item.stars
                                            ? "#a855f7"
                                            : "#e5e7eb"
                                    }
                                />
                            ))}
                            <span>
                                {item.stars} star{item.stars > 1 ? "s" : ""}
                            </span>
                        </div>
                        <div className="barWrapper">
                            <div
                                className="barFill"
                                style={{ width: `${item.percent}%` }}
                            />
                        </div>
                        <div className="percent">{item.percent}%</div>
                    </div>
                ))}
            </RatingDistribution>
        </>
    );
};

export default Analytics;
